import React, { useEffect } from "react";

const SITE_URL = "https://lazydayshome.com";

export function SEOHead({ title, description, keywords, structuredData, canonicalPath, noindex }) {
  useEffect(() => {
    const brand = "Lazy Days Home Services";
    // Avoid double-branding when a page already includes the brand in its title.
    const fullTitle = title ? (title.includes("Lazy Days") ? title : `${title} | ${brand}`) : brand;
    if (title) document.title = fullTitle;
    // robots: noindex pages (e.g. blogs/ZIP pages while SEO is paused); default index.
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) { robots = document.createElement("meta"); robots.name = "robots"; document.head.appendChild(robots); }
    robots.setAttribute("content", noindex ? "noindex, nofollow" : "index, follow");
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc && description) metaDesc.setAttribute("content", description);
    else if (description) { const m = document.createElement("meta"); m.name = "description"; m.content = description; document.head.appendChild(m); }
    const metaKey = document.querySelector('meta[name="keywords"]');
    if (metaKey && keywords) metaKey.setAttribute("content", keywords);
    else if (keywords) { const m = document.createElement("meta"); m.name = "keywords"; m.content = keywords; document.head.appendChild(m); }
    if (structuredData) {
      let el = document.getElementById("structured-data-ld");
      if (!el) { el = document.createElement("script"); el.id = "structured-data-ld"; el.type = "application/ld+json"; document.head.appendChild(el); }
      el.textContent = JSON.stringify(structuredData);
    }
    // Canonical URL — use explicit path or derive from current location
    const path = canonicalPath !== undefined ? canonicalPath : window.location.pathname;
    const canonicalUrl = `${SITE_URL}${path === "/" ? "" : path}${path === "/" ? "/" : ""}`;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = canonicalUrl;
    // Dynamic Open Graph tags per page
    const fullOgTitle = fullTitle;
    const ogUpdates = { "og:title": fullOgTitle, "og:description": description || "", "og:url": canonicalUrl };
    Object.entries(ogUpdates).forEach(([prop, val]) => {
      let meta = document.querySelector(`meta[property="${prop}"]`);
      if (meta) meta.setAttribute("content", val);
      else if (val) { meta = document.createElement("meta"); meta.setAttribute("property", prop); meta.content = val; document.head.appendChild(meta); }
    });
  }, [title, description, keywords, structuredData, canonicalPath, noindex]);
  return null;
}

export const LOCAL_BUSINESS_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Lazy Days Home Services",
  "image": "https://lazydayshome.com/images/logo.png",
  "url": "https://lazydayshome.com",
  "telephone": "(817) 277-7387",
  "email": "Info@LazyDaysHome.com",
  "address": { "@type": "PostalAddress", "addressLocality": "Arlington", "addressRegion": "TX", "addressCountry": "US" },
  "geo": { "@type": "GeoCoordinates", "latitude": 32.7357, "longitude": -97.1081 },
  "priceRange": "$$",
  "openingHoursSpecification": { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"], "opens": "08:00", "closes": "17:00" },
  "areaServed": [
    { "@type": "City", "name": "Arlington, TX" },
    { "@type": "City", "name": "Fort Worth, TX" },
    { "@type": "City", "name": "Grand Prairie, TX" },
    { "@type": "City", "name": "Kennedale, TX" },
    { "@type": "City", "name": "Mansfield, TX" }
  ],
  "serviceType": ["House Cleaning","Deep Cleaning","Move In/Out Cleaning","Office Cleaning","Maid Service"],
  "sameAs": ["https://www.facebook.com/lazydayshome"]
};
